<template>
    <div>
        <div class="uk-padding logo-struct">
            <div class="uk-grid-collapse" uk-grid>
                <div class="uk-width-expand" />
                <div class="logo-box uk-width-auto">
                    {{ getInfos.transfer.name }}
                    <span class="uk-margin-small-right" />
                    <img
                        :src="apiUrl + '/logos/' + getInfos.logo"
                        class="logo" />
                </div>
            </div>
        </div>

        <LoadingStruct class="transfer-struct" is-dark>
            <Card
                is-round
                :title="$t('transfer.does.not.exist')"
                is-dark
                class="uk-text-left"
                mode="default"
                is-centered>
                <InfoBox class="uk-text-left" mode="danger">
                    <Translate
                        translation-key="transfer.does.not.exist.message" />
                </InfoBox>
            </Card>
        </LoadingStruct>
    </div>
</template>

<script>
import InfoBox from '@/components/generic/InfoBox.vue';
import Translate from '@/components/Translate.vue';
import Card from '@/components/generic/Card.vue';
import LoadingStruct from '@/views/LoadingStruct.vue';

export default {
    name: 'Transfers',
    components: {LoadingStruct, Card, Translate, InfoBox},
};
</script>

<style lang="scss" scoped>
.transfer-struct {
    max-width: 400px;
    min-height: calc(100vh - 217px - 24px);
    padding-left: 20px;
}

.logo-box {
    backdrop-filter: saturate(180%) blur(20px);
    background-color: rgba(29, 29, 31, 0.3) !important;
    padding: 10px 20px;
    border-radius: 5px;
    font-weight: 500;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}
</style>
